import React from "react";

/**
 * Simple test to see if anything renders at all
 */
const PlayCockpitV2Test: React.FC = () => {
    return (
        <div style={{
            background: "red",
            color: "white",
            padding: "20px",
            fontSize: "24px",
            minHeight: "100vh",
        }}>
            <h1>🚨 COCKPIT V2 TEST - CAN YOU SEE THIS?</h1>
            <p>If you see this red screen, the route is working!</p>
            <p>Current URL should be: /play-cockpit-v2-test</p>
        </div>
    );
};

export default PlayCockpitV2Test;